export default "__VITE_ASSET__D3Q3_4Ou__"